import { __spreadArray } from "tslib";
/*
 * @Autor: fijizuo
 * @Date: 2021-10-14 14:34:49
 * @LastEditTime: 2021-10-28 12:58:02
 * @LastEditors: fijiZuo
 * @Description: Zimzalabim!
 */
import axios from 'axios';
import { arrayIncludes, objectValues, readCookie, stringIncludes } from './index';
import { ENV } from 'src/const';
function getCatptchaBaseUrl(env) {
    var _a;
    var url = 'https://captcha{{ENV}}xiaoeknow.com';
    var local = ['://localhost', '://127.0.0.1'];
    var MAP = (_a = {},
        _a[ENV.DEV] = '.inside.',
        _a[ENV.TEST] = '.test.',
        _a);
    if (env) {
        return url.replace('{{ENV}}', MAP[env] || '.');
    }
    // 修改判断规则，使规则支持官网url
    __spreadArray(__spreadArray([], objectValues(MAP), true), local, true).forEach(function (mark) {
        if (stringIncludes(window.location.origin, mark)) {
            // 本地自动替换成inside
            if (arrayIncludes(local, mark)) {
                mark = MAP.dev;
            }
            url = url.replace('{{ENV}}', mark);
        }
    });
    return url.replace('{{ENV}}', '.');
}
export function post(url, data, config) {
    if (data === void 0) { data = {}; }
    if (config === void 0) { config = {}; }
    var isXiaoeCloud = stringIncludes(window.location.origin, '.cloud.');
    var appIdKey = isXiaoeCloud ? 'app_id' : 'with_app_id';
    // APPID h5 、__app_id B端管理台 、 appId 新PC
    var appId = window.APPID || window.__app_id || window.appId || readCookie(appIdKey); // 登录时用with_app_id
    // 需要用来打灰度
    if (appId) {
        url = addParameterToURL(url, "app_id=".concat(appId));
    }
    return new Promise(function (resolve, reject) {
        axios.post(url, data, {
            baseURL: getCatptchaBaseUrl(config.env),
            headers: { 'content-type': 'application/json; charset=utf-8' },
        }).then(function (response) {
            resolve(response.data);
        }, function (err) {
            reject(err);
        });
    });
}
// 直接把参数添加到尾部
function addParameterToURL(_url, param) {
    _url += (_url.split('?')[1] ? '&' : '?') + param;
    return _url;
}
export default {
    post: post
};
//# sourceMappingURL=verifyHttp.js.map